<div class="position-relative" (clickOutside)="isOpen.set(false)" [id]="id">
  @if (label && labelType !== labelTypeOptions.PLACEHOLDER) {
    @let isFloating = labelType === labelTypeOptions.FLOATING && dateFormat === DatePickerTypes.DATEPICKER;
    @if (labelType === labelTypeOptions.STATIC) {
      <div class="d-flex gap-1 align-items-center">
        <ng-container
          [ngTemplateOutlet]="labelTemplate"
          [ngTemplateOutletContext]="{ $implicit: isFloating }"
        ></ng-container>
        @if (inputLabelTooltipText?.length) {
          <finxone-platform-tooltip
            [content]="inputLabelTooltipText"
            [textStyleClass]="tooltipTextStyleClass"
            [borderRadiusClass]="tooltipBorderRadiusClass"
          ></finxone-platform-tooltip>
        }
      </div>
    } @else {
      <ng-container
        [ngTemplateOutlet]="labelTemplate"
        [ngTemplateOutletContext]="{ $implicit: isFloating }"
      ></ng-container>
    }
  }

  <div class="position-relative">
    <!-- Prefix Content -->
    <ng-content select="[prefix]"></ng-content>
    <!-- Custom Template or Default Date Input -->
    <ng-container
      *ngIf="customDateInputTemplate; else datePickerTemplate"
      [ngTemplateOutlet]="customDateInputTemplate"
      [ngTemplateOutletContext]="{
        $implicit: {
          value: value,
          control: control,
          onInput: onInputChange.bind(this),
          onBlur: onTouched.bind(this),
          onFocus: onTouched.bind(this),
        },
      }"
    ></ng-container>
    <!-- Suffix Content -->
    <ng-content select="[suffix]"></ng-content>
  </div>
  <div
    *ngIf="
      (showErrors && control?.invalid && control?.touched) ||
      (dayFormControl && dayFormControl?.invalid && dayFormControl?.touched) ||
      (monthFormControl && monthFormControl?.invalid && monthFormControl?.touched) ||
      (yearFormControl && yearFormControl?.invalid && yearFormControl?.touched)
    "
    class="error-container"
    role="alert"
  >
    <div class="is-vertical-align mt-1">
      @for (error of control.errors | keyvalue; track error.key) {
        <small class="typog-xs text-error">
          {{ getErrorMessageBasedOnKey(error) }}
        </small>
      }
    </div>

    <!-- Custom Error Template -->
    <ng-container
      *ngIf="customErrorTemplate"
      [ngTemplateOutlet]="customErrorTemplate"
      [ngTemplateOutletContext]="{
        $implicit: {
          control: control,
          errors: control.errors,
        },
      }"
    ></ng-container>
  </div>
</div>

<ng-template #datePickerTemplate>
  @if (dateFormat === DatePickerTypes.DATEPICKER) {
    <hlm-date-picker
      (click)="control.disabled ? null : handleLabelClick()"
      [isOpen]="isOpen()"
      [iconColor]="'inherit'"
      [autoCloseOnSelect]="autoCloseOnSelect"
      (changed)="onChangeDateValue($event); onTouched(); isOpen.set(false)"
      (focus)="isOpen.set(true)"
      [min]="resolvedMinDate()"
      [max]="resolvedMaxDate()"
      [formControl]="control"
      [date]="date()"
      [userClass]="textStylingClass + ' ' + borderRadiusClass"
    >
      <div class="labelText labelIdle labelConfig">
        {{
          labelType === labelTypeOptions.PLACEHOLDER
            ? label || placeholder
            : labelType === labelTypeOptions.FLOATING
              ? ''
              : placeholder
        }}
      </div>
    </hlm-date-picker>
  } @else if (dateFormat === DatePickerTypes.INPUT) {
    <div class="d-flex" [style]="{ gap: spaceBetweenItem() }">
      <div class="w-[33.33%]">
        <finxone-input
          type="number"
          [inputMode]="'decimal'"
          [name]="'day'"
          [label]="'Day'"
          [formControl]="dayFormControl"
          [value]="dayFormControl?.value"
          [maxLength]="2"
        ></finxone-input>
      </div>

      <div class="w-[33.33%]">
        <finxone-select-dropdown
          id="month"
          label="Month"
          [formControl]="monthFormControl"
          [options]="allMonths"
          [appendToBody]="true"
          [optionLabelKey]="'name'"
          [optionValueKey]="'key'"
          [isScrollable]="isScrollable"
          [isScrollPeekEnabled]="isScrollPeekEnabled"
          [visibleItemsCount]="visibleItemsCount"
          [menuDirection]="menuDirection"
          [selectedOption]="selectedMonth"
        >
        </finxone-select-dropdown>
      </div>

      <div class="w-[33.33%]">
        <finxone-input
          type="number"
          [inputMode]="'decimal'"
          [name]="'year'"
          [label]="'Year'"
          [formControl]="yearFormControl"
          [maxLength]="4"
          [value]="yearFormControl?.value"
        ></finxone-input>
      </div>
    </div>
  }
</ng-template>

<ng-template #labelTemplate let-isFloating>
  <label
    [class.floatingLabelWithValue]="control.value && isFloating"
    [class.floatingLabel]="isFloating"
    [class.ml-8]="isFloating"
    [class.labelActive]="isOpen()"
    class="labelText labelIdle labelConfig"
    [for]="name"
    (click)="handleLabelClick()"
    >{{ label }}
  </label>
</ng-template>

@if (helperText) {
  <div class="py-2">
    <div [innerHTML]="helperText | safeHtml"></div>
  </div>
}
